export class GdsgRegionStatsPoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketStartMs",
            "baseName": "bucketStartMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "membersProcessed",
            "baseName": "membersProcessed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "failures",
            "baseName": "failures",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "queueRowsProcessed",
            "baseName": "queueRowsProcessed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "promoteLatencyP95Ms",
            "baseName": "promoteLatencyP95Ms",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "replicationLagP95Ms",
            "baseName": "replicationLagP95Ms",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "putAckToBackupLagP95Ms",
            "baseName": "putAckToBackupLagP95Ms",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bundleSizeAvgBytes",
            "baseName": "bundleSizeAvgBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sampleError",
            "baseName": "sampleError",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgRegionStatsPoint.attributeTypeMap;
    }
    constructor() {
    }
}
